module.exports = __webpack_public_path__ + "img/bg-frame.1e117053.png";